import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// This component forces the window to scroll to the top whenever the
// location path changes. React Router does not automatically reset
// scroll position on navigation, so pages can inherit the previous
// scroll position on mobile. Placing this inside the router ensures
// it runs on every route change.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 'behavior: "auto"' avoids the smooth scroll delay, you can
    // remove it if you prefer a smooth transition.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
